import { render } from "./HeroiconsSolidTicket.vue?vue&type=template&id=ef09c34c"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTicket.vue"]])

export default __exports__